module.exports = __webpack_public_path__ + "img/Icon_Doc_Estudiante.0f2b0395.svg";